import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {Link} from "react-router-dom";
import Routing from "../../../../Routing.ts";

export default function OpsigelseArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="paragraph">
                        <h2>Øv! Vi er kede af, at du overvejer at opsige dit abonnement</h2>
                        <p>
                            Vi vil nødig undvære dig, så derfor hører vi gerne fra dig, hvis du oplever problemer eller skal flytte
                            til en ny adresse, hvor du kan tage dit internet med.
                        </p>
                        <p>
                            Ønsker du at opsige dit abonnement, opfordrer vi til, at du ringer til os på <a
                            href="tel:+4561105080"
                        >61&nbsp;10&nbsp;50&nbsp;80</a>.
                        </p>
                        <p>
                            Alternativt kan du <Link to={Routing.Contact.Index}>sende os en besked</Link>.
                        </p>
                    </div>
                </div>
                <div className="article">
                    <div className="paragraph">
                        <h3>Du kan opsige dit abonnement med 30 dages varsel</h3>
                        <p>
                            Du kan opsige dit abonnement, når din <Link
                                to="/hjaelp/mit-abonnement/bindingsperiode"
                            >bindingsperiode</Link> er udløbet.
                            Din bindingsperiode starter den dato, dit internet er klar til brug.
                        </p>
                        <p>
                            Hvis du er ny kunde, kan du <Link
                                to="/hjaelp/mit-abonnement/fortrydelsesret"
                            >læse om din fortrydelsesret</Link>.
                        </p>
                    </div>
                </div>
                <div className="article">
                    <div className="paragraph">
                        <h3>Skal jeg returnere mit udstyr, når jeg opsiger?</h3>
                        <p>
                            Ja, du skal sende dit udstyr retur.{' '}
                            <Link
                                to="/hjaelp/udstyr/returner-udstyr"
                            >Læs mere om returneringen</Link>.
                        </p>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "mit-abonnement",
                        "article": "skal-du-flytte",
                        "name": "Skal du flytte?"
                    },
                    {
                        "category": "mit-abonnement",
                        "article": "overdrag-dit-internet-til-anden-person",
                        "name": "Overdrag dit internet til en anden"
                    },
                    {
                        "category": "mit-abonnement",
                        "article": "returner-udstyr",
                        "name": "Hvordan returnerer jeg mit udstyr?"
                    },
                    {
                        "category": "mit-abonnement",
                        "article": "bindingsperiode",
                        "name": "Hvor lang er min bindingsperiode"
                    }
                ]}
            />
        </>
    )
}
